module.exports = __webpack_public_path__ + "img/new-banking.b9dd4583.jpg";